// mc-buy-trust.js, Producer D, audit-2026-09-18
// Two jobs:
// 1. On mc-boutique-vsl.liquid the buy box is built by JavaScript (buildPage/kTop in the section's
//    own inline script), so the trust block is rendered ONCE into a hidden
//    <template id="mc-buy-trust-tpl"> right after <main id="app"></main> and this script clones it
//    after every .buy-actions block once buildPage() has run. On mc-koala-pdp.liquid the snippet
//    already renders in place via plain Liquid, so there is no #mc-buy-trust-tpl and this step is a
//    no-op there.
// 2. The dispatch cutoff clock (window.MC_FACTS.cutoff), which needs live Melbourne time regardless
//    of which page rendered it.
(function () {
  'use strict';

  function injectBuyTrust() {
    var tpl = document.getElementById('mc-buy-trust-tpl');
    if (!tpl) return;
    var targets = document.querySelectorAll('.buy-actions:not([data-mcbt-done])');
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      el.setAttribute('data-mcbt-done', '1');
      var clone = tpl.content.cloneNode(true);
      var anchor = el.nextElementSibling && el.nextElementSibling.classList.contains('ship-trust') ? el.nextElementSibling : el;
      var block = clone.firstElementChild;
      var rows = block.querySelector('.mcbt-rows');
      if (anchor !== el && rows) {
        // Fold the trust rows into the section's own ship-trust group so they read as one row set,
        // whatever else (the consult card) gets moved in after it later.
        while (rows.firstElementChild) anchor.appendChild(rows.firstElementChild);
        rows.parentNode.removeChild(rows);
        anchor.insertAdjacentElement('afterend', block); // kept even when empty: the reviews mini widget anchors on it
      } else {
        anchor.insertAdjacentElement('afterend', block);
      }
    }
    var dtpl = document.getElementById('mc-delivery-tpl');
    if (dtpl) {
      var slots = document.querySelectorAll('[data-mc-delivery-slot]:not([data-mcbt-done])');
      for (var j = 0; j < slots.length; j++) {
        slots[j].setAttribute('data-mcbt-done', '1');
        slots[j].appendChild(dtpl.content.cloneNode(true));
      }
    }
  }

  var DAY_ABBR = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAY_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function melbourneParts() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Australia/Melbourne',
      hour12: false,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
    var map = {};
    fmt.formatToParts(new Date()).forEach(function (p) { map[p.type] = p.value; });
    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0; // some engines render midnight as "24" with hour12:false
    return { weekday: map.weekday, hour: hour, minute: parseInt(map.minute, 10) };
  }

  function formatDuration(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (h > 0) return h + 'h ' + m + 'm';
    return m + 'm';
  }

  function cutoffText(cutoff) {
    var parts = melbourneParts();
    var todayIdx = DAY_ABBR.indexOf(parts.weekday);
    var cutoffIdx = (cutoff.days || []).map(function (d) { return DAY_ABBR.indexOf(d); });
    var cutoffMinutes = 14 * 60;
    if (cutoff.time && /^\d{1,2}:\d{2}$/.test(cutoff.time)) {
      var bits = cutoff.time.split(':');
      cutoffMinutes = parseInt(bits[0], 10) * 60 + parseInt(bits[1], 10);
    }
    var nowMinutes = parts.hour * 60 + parts.minute;
    var isCutoffDay = todayIdx >= 0 && cutoffIdx.indexOf(todayIdx) !== -1;
    var remaining = cutoffMinutes - nowMinutes;

    if (isCutoffDay && remaining > 0) {
      return 'Order in the next ' + formatDuration(remaining) + ' and it leaves our Melbourne warehouse today. Melbourne metro orders arrive the next business day, everywhere else runs ' + (window.MC_FACTS ? window.MC_FACTS.deliveryWindow : '2 to 12') + ' business days from dispatch.';
    }
    var nextIdx = -1;
    for (var i = 1; i <= 7; i++) {
      var idx = (todayIdx + i) % 7;
      if (cutoffIdx.indexOf(idx) !== -1) { nextIdx = idx; break; }
    }
    var nextDayName = nextIdx >= 0 ? DAY_FULL[nextIdx] : 'the next dispatch day';
    return 'Order today and it leaves our Melbourne warehouse on ' + nextDayName + '.';
  }

  function updateCutoffs() {
    var facts = window.MC_FACTS;
    if (!facts || !facts.cutoff || !facts.cutoff.enabled) return;
    var nodes = document.querySelectorAll('[data-mcbt-cutoff]');
    if (!nodes.length) return;
    var text = cutoffText(facts.cutoff);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = text;
      nodes[i].hidden = false;
    }
  }

  function init() {
    injectBuyTrust();
    updateCutoffs();
    setInterval(updateCutoffs, 30000);

    var app = document.getElementById('app');
    if (app && window.MutationObserver) {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          injectBuyTrust();
          updateCutoffs();
        }, 60);
      });
      mo.observe(app, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
